import List from 'src/storage/list';
import constants from 'src/constants';
import { userFullName } from 'src/helpers';

class ClinicDoctorsModel extends List {
  id = 'ClinicDoctorsModel';
  defaultState = () => ({
    current: 'recent',
    total: 0,
    tab: 'doctors',
    pageIndex: 0,
    updating: {},
    hospitalIds: [],
    sortBy: {
      sortKey: 'joiningDate',
      desc: true
    }
  });
  refreshOnInit = true;
  refreshOnSubscribe = false;
  sortBy = {};

  apiConfig = {
    refresh: {
      url: 'clinic/doctor/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'clinic/doctor/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'clinic/doctor/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    update: {
      url: 'clinic/doctor/update',
      validation: {
        hospitalIds: 'hospitalIds'
      },
      cancellable: true
    },
    remove: {
      url: 'clinic/doctor/remove',
      validation: {},
      cancellable: true
    },
    saveComission: {
      url: 'clinic/doctor/update/comission',
      validation: {},
      cancellable: true
    },
    active: {
      url: 'clinic/doctor/active',
      validation: {
        id: 'baseId',
        active: 'boolean'
      },
      cancellable: true
    },
    doctor_detail: {
      url: 'clinic/doctor/list',
      validation: {
        doctorId: 'number'
      },
      cancellable: true
    }
  };

  _events = {
    'ws:modify_doctor': 'onInviteDoctor',
    profile: 'handleChangeProfileAndSwitchAccount'
  };
  onInviteDoctor = (data) => {
    if (data.removedDate) this.removeItem(data.id);
    else {
      this._mergeItems([data], null, true);
      this.trigger();
    }
  };

  _matchMergeItem = (n, o) => ({ ...o, ...n });

  onChangeComission = (item, v) => {
    if (Number.isNaN(parseFloat(v))) return;

    let items = this.items();
    let clinicId = this.userId || 0;
    if (v < 0) v = 0;
    if (v > 100) v = 100;
    if (!item.clinics) item.clinics = {};
    if (!item.clinics[clinicId]) item.clinics[clinicId] = { comission: 0 };
    if (!item.clinics[clinicId].comission_original)
      item.clinics[clinicId].comission_original = item.clinics[clinicId].comission;
    item.clinics[clinicId].comission = v;
    this.setListState({ items }, this.getCurrentId());
    clearTimeout(this.saveComissionTimeout);
    if (v.toString().length > 0)
      this.saveComissionTimeout = setTimeout(() => this.saveComission(item), 1000);
  };

  saveComission = (item) => {
    clearTimeout(this.saveComissionTimeout);
    this.cancelApi('saveComission');
    let clinicId = this.userId || 0;
    if (!item.clinics) item.clinics = {};
    if (!item.clinics[clinicId]) item.clinics[clinicId] = {};
    let v = item.clinics[clinicId].comission;
    let originalValue = item.clinics[clinicId].comission_original;
    this.api(
      'saveComission',
      { doctorId: item.id, key: 'comission', value: v },
      (err, res, success) => {
        let items = this.items();
        if (success) {
          item.clinics[clinicId].comission_original = v;
        } else {
          item.clinics[clinicId].comission = originalValue;
          this.setListState({ items, _updated: Date.now() }, this.getCurrentId());
        }
      }
    );
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    if (this.state.specialist) {
      req.specialist = this.state.specialist;
    }
    if (this.state.hospitalId) {
      req.hospitalIds = [this.state.hospitalId];
    }
    return req;
  }
  updateDoctor = (id, cb) => {
    let req = {
      id,
      hospitalIds: this.input('hospitalIds')
    };
    this.api('update', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.onInviteDoctor({ ...data });
      }
    });
  };
  remove = (item, cb) => {
    let req = {
      doctorId: item.id
    };
    this.api('remove', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (!err) {
        this.onInviteDoctor({ id: item.id, removedDate: Date.now() });
      }
    });
  };

  updateActive = (item) => {
    const active = item.status === constants.general.userStatus.disabled;
    this.setState({
      updating: { [item.id]: { active } }
    });
    this.api('active', { id: item.id, active }, (err, data) => {
      !err && this.updateItem({ ...item, ...data.data });
      this.setStateSilent({ updating: {} });
    });
  };

  checkWithUpdating = (item, key, def) => {
    return this.state.updating[item.id] && this.state.updating[item.id][key] !== undefined
      ? this.state.updating[item.id][key]
      : def;
  };
  doctorDetail = (id, cb) => {
    let req = {
      doctorId: id,
      skip: 0,
      limit: 1
    };

    this.api('doctor_detail', req, (err, data, success) => {
      if (success) {
        data = data.items[0];
        this.setState({
          fullname: userFullName(data),
          phoneNumber: data.phoneNumber || '',
          email: data.email || '',
          hospitalIds: data.hospitalIds
        });
      }
      cb(err, data, success);
    });
  };
}

const model = new ClinicDoctorsModel();
export default model;
